module.exports = __webpack_public_path__ + "static/media/check.fa6cf436.svg";